import script from "./ArchivePreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArchivePreview.vue?vue&type=script&lang=ts&setup=true"

import "./ArchivePreview.vue?vue&type=style&index=0&id=98a522d6&lang=scss"

const __exports__ = script;

export default __exports__